import { HttpRepository } from '@/modules/shared/shared/domain/repositories/http.repository';

class TokensRepository extends HttpRepository {
    private static readonly RESOURCE = 'tokens';

    async logout(): Promise<{ data: any }> {
        return this.delete(
            this.createUri([`${TokensRepository.RESOURCE}`, 'logout']),
            this.createAuthorizationHeader(),
        );
    }
}

export const tokensRepository = new TokensRepository();
